exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size[data-v-509293c4]{font-size:32px}@media (max-width: 7678px){.icon-size[data-v-509293c4]{font-size:26px}}\n", ""]);

// exports
